// import { useContext } from "react";
import { 
	// AboutUsContacts, 
	AboutUsContainer, AboutUsImg, AboutUsInfo, AboutUsText, AboutUsWrapper, SmokeEffect, TT } from "./about-us.styles";

import AboutService from '../../assets/img/about-us.jpg';
// import Button from "../button/button.component";
// import externalLink from '../../assets/icons/icon-external-link-blue.svg'
// import smokeEffect from '../../assets/img/smoke-left-min.png';
import sec_bg_img from '../../assets/img/opacity-logo.webp';
// import { Link } from "react-scroll";
// import { LanguageContext } from "../../contexts/language.context";
// import yt from '../../assets/img/yt.svg';
import tt from '../../assets/img/tt.svg';
import iconExternalLink from '../../assets/icons/icon-external-link_blue.svg';
import "./styles.scss"
import Button from "../button/button.component";
import fb from '../../assets/icons/fb-ico.svg';
import yt from '../../assets/icons/yt-ico.svg';
import ig from '../../assets/icons/ig-ico.svg';


const AboutUs =({props})=>{

	const descriptionList = [props[9], props[10], props[11]]

	console.log("descriptionList", descriptionList)


	return(
		<AboutUsWrapper className="about-us" id="about-us">
			<AboutUsContainer>
				<AboutUsImg>
					<img src={AboutService} alt="" />
				</AboutUsImg>
				<AboutUsInfo>
					<AboutUsText>
						<h2>{props[1]}</h2>
						<p style={{fontWeight: '500', padding:0, margin:0}}>{props[2]}</p>

							<ul style={{listStyle: 'disc', paddingLeft: '20px', paddingTop: 5, marginTop: 0}}>
								{
									descriptionList.map((item, index) => (
										<li key={index} style={{marginTop: '2px'}}>
											{item}
										</li>
									))
								}
							</ul>

						{/*<p>{props[9]}</p>*/}
						{/*<p>{props[10]}</p>*/}
						<p style={{fontWeight: '500'}}>{props[15]}</p>
						{/* <h2 id="products">{props[3]}</h2>
						<p>{props[4]}<span> {props[4.1]} </span> {props[4.2]}</p>
						<h2>{props[5]}</h2>
						<p>{props[6]}</p> */}
					</AboutUsText>
					<div className="links-wrapper">

					{/*<a className="link-item" target="_blank" href={'https://www.youtube.com/watch?v=8ElJGBW7Brs&t=4401s&ab_channel=OneDayTV'}>*/}
					{/*	<img src={yt} alt="YouTube"/>*/}
					{/*</a>*/}
					{/*<TT>*/}

					{/*<a className="link-item" target="_blank" href={'https://www.tiktok.com/@tudorelsoltan?_t=ZM-8u1hVUumOxD&_r=1'}>*/}
					{/*	<img src={tt} alt="YouTube"/>*/}
					{/*</a>*/}
					{/*</TT>*/}


					{/*<a className="link-item see-more" target="_blank" href="https://docs.google.com/document/d/1F-mnkfcrkw1-UhSMZE6mWcJQtQUL9V7l1o5PYCDkJJg/edit?usp=sharing">*/}
					{/*	{props[12]}<img src={iconExternalLink} alt=""/></a>*/}
					{/* <AboutUsContacts>
						<Link to="form" spy={true} smooth={true} offset={0} duration={500}>
							<Button children={props[7]}/>
						</Link>
						<a rel="noreferrer" target='_blank' href="https://docs.google.com/document/d/1YJpYhOyVK7dvbNsJK8R1sQcQOcPYZSyBv4UecnTto-k/edit">
							<button className="purpleBtn">
								<span>{props[8]}</span>
								<img src={externalLink} alt=""/>
							</button>
						</a>
					</AboutUsContacts> */}

						<div className={'link-container'}>
						<a className="link-item" target="_blank" href={'https://www.tiktok.com/@autofficina360padova?_r=1&_t=ZN-91MVERTd1zK'}>
							<img src={yt} alt="YouTube"/>
						</a>


						<a className="link-item" target="_blank" href={'https://www.facebook.com/share/1Fk2h6sG3z/?mibextid=wwXIfr'}>
							<img src={fb} alt="YouTube"/>
						</a>




						<a className="link-item" target="_blank" href={'https://www.instagram.com/autofficina360padova?igsh=MXdjMWJrNXZqZGttOQ%3D%3D&utm_source=qr'}>
							<img src={ig} alt="YouTube"/>
						</a>



						</div>

					</div>
				</AboutUsInfo>
			</AboutUsContainer>
			
		</AboutUsWrapper>
	)
}

export default AboutUs;